let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8DuKk")).then(() => parcelRequire('d2VHY'));